<template>
  <div class="add headFixed bodyPd hasBotBtns">
    <div class="fixed_head">
      <div class="content">
        <div class="go_back">
          <span @click="$router.back(-1)" class="goBackBtn"></span>
          <span class="titles">场景管理</span>
          <span class="right addHome" @click="addHome()">添加</span>
        </div>

      </div>
    </div>
    <!-- 住宅列表 -->
    <div class="roomWrapper">
      <div class="list list_prev list_normal">
        <p class="titleTip">请选择设备所在的地址或小区名称</p>
        <div class="item choose-item" :class="index==currentIndex?'choose-active':''"
             v-for="(data,index) in list"
             @click="chooseRoom(index)"
             :key="index">
          <div class="r-box">
            <span class="r-con">{{ data.name }}</span>
            <span class="icon-check"></span>
          </div>
        </div>
      </div>
    </div>


    <div class="botBtns">
      <div>
        <mt-button :disabled="disabled" size="large" class="btn-primary" @click="eqChooseRoom">确定</mt-button>
      </div>
    </div>
    <mt-popup v-model="popupVisible">
      <div class="smart-modal">
        <h1>添加场景名称</h1>
        <input type="text" name="" id="" v-model="homeName">
        <div class="smart-modal-foot">
          <span @click="handleClick">取消</span>
          <span @click="handleAdd">确定</span>
        </div>
      </div>
    </mt-popup>
  </div>
</template>
<script>
import {Popup, Toast} from 'mint-ui';
import HeadNav from '../../headNav/headNav'

export default {
  name: 'add',
  data() {
    return {
      // 最后提交的参数
      number: null,
      name: null,
      password: null,
      sceneId: null,
      type: null,

      popupVisible: false,
      homeName: null,
      list: [],
      currentIndex: 0,
      disabled: false,
      eqId: null,
    }
  },
  mounted() {
    // 添加场景
    if (this.getType() == 1) {
      let params = this.Store.getEqInfo();
      if (!params) {
        this.goHome();
      }
      this.name = params.name;
      this.number = params.number;
      this.password = params.password;
      this.type = params.type;
    }

    // 编辑修改场景
    if (this.getType() == 2) {
      this.eqId = this.$route.query.id;
    }


    if (this.eqId) {
      this.eqDetail(this.eqId);
    }
    this.getEqRoomList();
  },
  components: {
    'HeadNav': HeadNav
  },
  methods: {
    getType() {
      return this.$route.params.type;
    },
    goHome() {
      this.$router.push({
        name: 'Equipment',
        params: {}
      });
    },
    eqDetail(id) {
      this.Api.eqDetail(id, (msg) => {
        if (msg.body) {
          this.sceneId = msg.body.useSceneId;
          if (this.list) {
            let list = this.list;
            for (let i = 0; i < list.length; i++) {
              if (list[i].id == this.sceneId) {
                this.currentIndex = i;
              }
            }
          }
        }
      })
    },
    getEqRoomList() {
      let str = '';
      str = str + 'pageNo=1';
      str = str + '&pageSize=100';
      this.Api.useSceneList(str, (msg) => {
        if (msg.code == 200) {
          this.list = msg.data;

          if (this.list && this.list.length > 0) {
            this.sceneId = this.list[0].id;
          }

          if (this.getType() == 2) {
            let list = this.list;
            for (let i = 0; i < list.length; i++) {
              if (list[i].id == this.sceneId) {
                this.currentIndex = i;
              }
            }
          }

        }
      });
    },
    handleClick() {
      this.popupVisible = false;
    },
    addHome() {
      this.popupVisible = true;
    },
    handleAdd() {
      if (this.homeName) {
        let params = {};
        params.name = this.homeName;
        if (this.list.length >= 100) {
          this.popupVisible = false;
          Toast('场景最多只能添加100种');
        } else {
          this.Api.useSceneAdd(params, () => {
            this.getEqRoomList();
            this.popupVisible = false;
            this.homeName = null;
          });
        }
        this.popupVisible = false;
        this.homeName = null;
      }
    },
    chooseRoom(index) {
      let list = this.list;
      this.currentIndex = index;
      this.sceneId = list[index].id;
    },
    eqChooseRoom(equipmentUsage) {
      let arr = [];
      if (this.eqId) {
        arr.push('id=' + this.eqId)
      }
      let str = '';
      if (arr.length > 0) {
        str = arr.join('&');
        str = '?' + str;
      }
      console.log(this.sceneId !== null)
      if (this.sceneId !== null){
        let params = {
          name: this.name,
          number: this.number,
          password: this.password,
          sceneId: this.sceneId,
          type: this.type
        };
        this.Store.setEqInfo(params);
        this.$router.push({
          path: this.PATH.getChooseRoom() + this.getType() + '/' + this.sceneId + str
        });
      }else{
        Toast("请添加场景")
      }
    }
  }
}
</script>

<style scoped>
@import url('../equipment.css');

.list_normal {
  margin-top: 54px;
}

.list_prev .item {
  background-image: none;
}

.list_prev .item:last-child {
  border-bottom: none;
}

/* yh */
.r-box {
  height: 44px;
}

.r-con {
  display: inline-block;
  width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.titles {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>




// WEBPACK FOOTER //
// src/components/equipment/scene/chooseHome.vue